"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _progress = require("@jsluna/progress");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Loader = function Loader(_ref) {
  var className = _ref.className,
      message = _ref.message;
  return /*#__PURE__*/_react.default.createElement(_progress.ProgressIndicator, {
    loading: true,
    preventFocus: true,
    className: className,
    message: message
  }, /*#__PURE__*/_react.default.createElement(_progress.ProgressSpinner, null));
};

Loader.propTypes = {
  className: _propTypes.default.string,
  message: _propTypes.default.string
};
Loader.defaultProps = {
  className: '',
  message: ''
};
var _default = Loader;
exports.default = _default;